import * as React from 'react';
import { MultiSelectQuestion, SingleSelectQuestion } from '../../../../commonv3/types/writingQuestions';
import { CheckBox } from '../../atoms/forms/CheckBox';
import classNames from 'classnames';
import { MultiSelectAnswerState, SingleSelectAnswerState } from './states/QuestionAnswerState';
import './writingQuestionView.module.scss';
import { observer } from 'mobx-react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';

export const BaseQuestionView = ({ children }) => <div styleName="question">{children}</div>;
const QuestionHeader = ({ index, title, isAnswer, showAnswer }) => (
    <div styleName="question-header">
        <div
            styleName={classNames(
                { score: showAnswer },
                { correct: showAnswer && isAnswer },
                { wrong: showAnswer && !isAnswer }
            )}
        >
            <span styleName="index">Q{index}.</span> {showAnswer ? (isAnswer ? '正解' : '不正解') : ''}
        </div>
        <div styleName="title">{title}</div>
    </div>
);
const QuestionDescription = ({ description }) => (
    <div styleName="description" dangerouslySetInnerHTML={{ __html: description }} />
);
const QuestionOptions = ({ children }) => <div styleName="question-options">{children}</div>;
const AnswerLabel = ({ isAnswer }) => (
    <div styleName={classNames('answer-label', { correct: isAnswer })}>{isAnswer ? '正解' : 'あなた'}</div>
);
const QuestionOption = ({ label, selected, isAnswer, onClick, showAnswer }) => (
    <div
        styleName={classNames(
            'question-option',
            { correct: showAnswer && isAnswer },
            { wrong: showAnswer && selected && !isAnswer }
        )}
        onClick={onClick}
    >
        <CheckBox styleName="checkbox" selected={selected} />
        <div styleName="question-option-label">
            {label}
            {showAnswer && selected && <AnswerLabel isAnswer={isAnswer} />}
            {showAnswer && !selected && isAnswer && <AnswerLabel isAnswer={isAnswer} />}
        </div>
    </div>
);
const QuestionAnswer = ({ choices, answerDescription }) => (
    <div styleName="question-answer">
        <div styleName="answer-summary">
            正解：{choices
                .filter((c) => c.answer)
                .map((c) => c.label)
                .join('、')}
        </div>
        <div styleName="answer-description" dangerouslySetInnerHTML={{ __html: answerDescription }} />
    </div>
);
const QuestionFooter = ({ onClick, disabled, lastQuestion, submitting }) => (
    <div styleName="question-footer">
        <Button styleName="button" type="primary" size="m" loading={submitting} onClick={onClick} disabled={disabled}>
            {lastQuestion ? '採点へ' : '選択して次へ'}
        </Button>
    </div>
);

type SingleSelectProps = {
    index: number;
    question: SingleSelectQuestion;
    answerState: SingleSelectAnswerState;
    showAnswer: boolean;
    onNextClick?: () => any;
    lastQuestion?: boolean;
    submitting?: boolean;
};

@observer
export class SingleSelectQuestionView extends React.Component<SingleSelectProps> {
    answerQuestion = (answerState, choice, showAnswer) => {
        !showAnswer && answerState.selectOption(choice);
    };
    render() {
        const { index, question, answerState, showAnswer, onNextClick, lastQuestion, submitting = false } = this.props;
        return (
            <div>
                <BaseQuestionView>
                    <QuestionHeader
                        index={index}
                        title={question.sentence}
                        isAnswer={answerState.isCorrect()}
                        showAnswer={showAnswer}
                    />
                    {question.description && <QuestionDescription description={question.description} />}
                    <QuestionOptions>
                        {question.content.choices.map((choice) => (
                            <QuestionOption
                                key={choice.id}
                                label={choice.label}
                                isAnswer={choice.answer}
                                selected={answerState.isSelected(choice)}
                                onClick={() => this.answerQuestion(answerState, choice, showAnswer)}
                                showAnswer={showAnswer}
                            />
                        ))}
                    </QuestionOptions>
                    {showAnswer ? (
                        <QuestionAnswer
                            choices={question.content.choices}
                            answerDescription={question.answer_description}
                        />
                    ) : (
                        <QuestionFooter
                            onClick={onNextClick}
                            disabled={answerState.selectedOptionId == null}
                            lastQuestion={lastQuestion}
                            submitting={submitting}
                        />
                    )}
                </BaseQuestionView>
            </div>
        );
    }
}

type MultiSelectProps = {
    index: number;
    question: MultiSelectQuestion;
    answerState: MultiSelectAnswerState;
    showAnswer: boolean;
    onNextClick?: () => any;
    lastQuestion?: boolean;
    submitting?: boolean;
};

@observer
export class MultiSelectQuestionView extends React.Component<MultiSelectProps> {
    answerQuestion = (answerState, choice) => {
        answerState.selectOption(choice);
    };
    render() {
        const { index, question, answerState, showAnswer, onNextClick, lastQuestion, submitting = false } = this.props;
        return (
            <div>
                <BaseQuestionView>
                    <QuestionHeader
                        index={index}
                        title={question.sentence}
                        isAnswer={answerState.isCorrect()}
                        showAnswer={showAnswer}
                    />
                    {question.description && <QuestionDescription description={question.description} />}
                    <QuestionOptions>
                        {question.content.choices.map((choice) => (
                            <QuestionOption
                                key={choice.id}
                                label={choice.label}
                                isAnswer={choice.answer}
                                selected={answerState.isSelected(choice)}
                                onClick={() => this.answerQuestion(answerState, choice)}
                                showAnswer={showAnswer}
                            />
                        ))}
                    </QuestionOptions>
                    {showAnswer ? (
                        <QuestionAnswer
                            choices={question.content.choices}
                            answerDescription={question.answer_description}
                        />
                    ) : (
                        <QuestionFooter
                            onClick={onNextClick}
                            submitting={submitting}
                            disabled={answerState.selectedOptionIds.length == 0}
                            lastQuestion={lastQuestion}
                        />
                    )}
                </BaseQuestionView>
            </div>
        );
    }
}
